import { Injectable } from '@angular/core';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../config/auth.config';
import { MsalCleanupService } from './msal-cleanup.service';

@Injectable({
  providedIn: 'root'
})
export class MsalInitService {
  private msalInstance: PublicClientApplication | null = null;
  private initPromise: Promise<PublicClientApplication> | null = null;

  constructor(private cleanupService: MsalCleanupService) {
    //this.initializeMsal();
  }

  private async initializeMsal(): Promise<void> {
    try {
      console.log('🚀 Iniciando MSAL...');
      
      // 1. MSAL uses sessionStorage to track interaction state.
      // Do NOT clear interaction state here, because we might be returning from a redirect!
      

      // 2. Crear instancia MSAL
      this.msalInstance = new PublicClientApplication(msalConfig);
      
      // 3. Inicializar MSAL
      await this.msalInstance.initialize();
      
      // 4. Manejar redirect promise para limpiar cualquier estado pendiente
      await this.msalInstance.handleRedirectPromise().catch((error) => {
        console.warn('⚠️ Error en redirect promise (normal en inicio limpio):', error);
        // Si hay error de interacción, limpiar estado
        if ((error as any)?.message?.includes('interaction_in_progress')) {
          console.log('🧹 Limpiando estado por error de interacción...');
          this.cleanupService.clearInteractionState();
        }
      });
      
      console.log('✅ MSAL initialized successfully');
    } catch (error) {
      console.error('❌ MSAL initialization failed:', error);
      
      // Si el error es de interacción en progreso, intentar limpiar y reiniciar
      if ((error as any)?.message?.includes('interaction_in_progress')) {
        console.log('🔄 Intentando recuperación por error de interacción...');
        await this.recoverFromInteractionError();
      } else {
        throw error;
      }
    }
  }

  private async recoverFromInteractionError(): Promise<void> {
    try {
      console.log('🛠️ Iniciando recuperación de error de interacción...');
      
      // Limpiar completamente el estado
      await this.cleanupService.clearAllMsalState();
      
      // Esperar un poco para que se complete la limpieza
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Crear nueva instancia
      this.msalInstance = new PublicClientApplication(msalConfig);
      await this.msalInstance.initialize();
      
      console.log('✅ Recuperación exitosa');
    } catch (recoveryError) {
      console.error('❌ Error en recuperación:', recoveryError);
      throw recoveryError;
    }
  }

  async getMsalInstance(): Promise<PublicClientApplication> {
    if (!this.initPromise) {
      this.initPromise = this.initializeMsal().then(() => {
        if (!this.msalInstance) {
          throw new Error('MSAL instance not created');
        }
        return this.msalInstance;
      });
    }
    
    return this.initPromise;
  }

  getInstance(): PublicClientApplication | null {
    return this.msalInstance;
  }

  isInitialized(): boolean {
    return this.msalInstance !== null;
  }

  /**
   * Fuerza una limpieza completa y reinicialización
   */
  async forceReset(): Promise<PublicClientApplication> {
    console.log('🔄 Forzando reset completo de MSAL...');
    
    this.msalInstance = null;
    this.initPromise = null;
    
    await this.cleanupService.clearAllMsalState();
    await this.initializeMsal();
    
    if (!this.msalInstance) {
      throw new Error('Failed to reset MSAL instance');
    }
    
    return this.msalInstance;
  }

  /**
   * Obtiene reporte de diagnóstico
   */
  getDiagnosticReport(): any {
    return this.cleanupService.diagnosticReport();
  }
}